import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Swal from 'sweetalert2';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const CheckoutForm = () => {
    const { t } = useTranslation();
    const token = localStorage.getItem('authToken');
    const id = localStorage.getItem('id');
    const role = localStorage.getItem('role');  // Assuming the role is saved in localStorage
    const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [codePromo, setCodePromo] = useState('');
    const [discount, setDiscount] = useState(0);
    const [message, setMessage] = useState('');
    const [customer, setCustomer] = useState({
        Name: '',
        Email: '',
        Phone: '',
        Address: '',
        City: '',
    });
const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, [token, role, navigate]);

    // Handle customer input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCustomer((prev) => ({ ...prev, [name]: value }));
    };

    // Handle quantity change
    const handleQuantityChange = (productID, newQuantity) => {
        if (newQuantity < 1) return;

        const updatedCart = cart.map(item =>
            item.productID === productID ? { ...item, quantity: newQuantity } : item
        );
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    // ✅ Handle item removal
    const handleRemoveItem = (productID) => {
        const updatedCart = cart.filter(item => item.productID !== productID);
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
          setIsSubmitting(true); // ✅ bouton devient "en cours..." + désactivé

if (!/^0[5-7][0-9]{8}$/.test(customer.Phone)) {
  Swal.fire('Erreur', 'Le numéro de téléphone doit commencer par 0 et contenir 10 chiffres valides du Maroc.', 'error');
  setIsSubmitting(false); // Reset the button state
  return;
}
        let supplierId = id;
        if (codePromo) {
            try {
                const response = await axios.get(`https://elanciabioapi.com/api/supplier-from-code/${codePromo}`);
                supplierId = response.data.supplier_id;
            } catch (error) {
                Swal.fire('Erreur', t('Code_promo_invalide'), 'error');
                return;
            }
        }
        const customerWithSupplier = {
            ...customer,
            ...(supplierId && { SupplierID: supplierId }), // Only include it if supplierId is NOT null
        };
        try {
            // Create the customer
            const customerResponse = await axios.post('https://elanciabioapi.com/api/customers/create', customerWithSupplier, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { 'Authorization': `Bearer ${token}` }), // optional if logged in
                },
            });

            const customerId = customerResponse.data.customer.CustomerID;

            // Create the order
            const orderData = {
                product_ids: cart.map(item => item.productID),
                prices: cart.map(item => item.productPrice), // <== Add this
                quantities: cart.map(item => item.quantity),
                customer_id: customerId,
                promo_code: codePromo,
                supplierId: id,
            };

            const orderResponse = await axios.post('https://elanciabioapi.com/api/orders/create', orderData, {
                
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { 'Authorization': `Bearer ${token}` }), // optional if logged in
                },
            });

            // Show success message
            Swal.fire(t('Commande_reussie'), t('Commande_succes'), 'success');

            // Clear cart from localStorage
            localStorage.removeItem('cart');

            // Redirect user
            navigate('/Boutique');

        } catch (error) {
            // Log the full error object and details
setIsSubmitting(false); // ✅ Reset

            if (error.response) {

                if (error.response.data.error === 'Your account has been deleted.') {
                    Swal.fire('Erreur!', 'Votre compte a été supprimé.', 'error');
        localStorage.clear();
        navigate('/signup'); // Replace with the actual path to the register page
		
                } else {
                    Swal.fire('Erreur!', error.response.data.message || 'Il y a eu un probléme, veuillez réessayer.', 'error');
                }
            } else if (error.request) {
                // If the error contains a request (network error)
                console.error("Request data:", error.request);
                Swal.fire('Erreur!', 'Probléme de connexion réseau, veuillez réessayer.', 'error');
            } else {
                // For other errors (like bad configuration)
                console.error("Error details:", error);
                Swal.fire('Erreur!', 'Il y a eu un probléme, veuillez réessayer.', 'error');
            }
        }
    };
const calculateSubtotal = () => {
  return cart.reduce((total, item) => total + item.productPrice * item.quantity, 0);
};

const calculateDeliveryFee = () => {
  return calculateSubtotal() > 300 ? 0 : 0;
};

const calculateTotal = () => {
  const subtotal = discount > 0 ? discount : calculateSubtotal();
  return subtotal + calculateDeliveryFee();
};
      const handlePromoCodeApply = async () => {
        if (!codePromo) {
setMessage(t('Entrer_code_promo')); 
          return;
        }
        try {
            const response = await axios.get(`https://elanciabioapi.com/api/supplier-from-code/${codePromo}`);
            if (response.data) {
                const discountRate = 0.15; // 15%
                const totalPrice = cart.reduce((total, item) => total + item.productPrice * item.quantity, 0);
                const discountAmount = discountRate * totalPrice;
                const finalPrice = parseFloat((totalPrice - discountAmount).toFixed(2));
                setDiscount(finalPrice);

            setMessage(t('Code_promo_succes'));
          } else {
            setMessage(t('Code_promo_invalide'));
          }
        } catch (error) {
          setMessage(t('Code_promo_invalide'));
        }
      };

    return (
        <AnimationRevealPage>
            <Light />
            <div className="container">
                <div className="row">
                    <div className="col-xl-8">
                        <div className="card border shadow-none">
                            <div className="card-body">
                                {cart.length > 0 ? (
                                    <>
                                        <ul className="list-group">
                                            {cart.map((item, index) => (
                                                <li className="list-group-item" key={index}>
                                                    <div className="d-flex align-items-start border-bottom pb-3">
                                                        <div className="me-4">
                                                            <img src={`https://elanciabioapi.com/storage/${item.productImage}`} alt="" className="avatar-lg rounded" />
                                                        </div>
                                                        <div className="flex-grow-1 align-self-center overflow-hidden">
                                                            <h5 className="text-truncate font-size-18 text-dark">{item.productName}</h5>
                                                            <p className="text-muted mb-0">{t('Prix')}: <strong>{item.productPrice} DH</strong></p>
                                                            <div className="d-flex align-items-center">
                                                                <span className="me-2">{t('quantity')}:</span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={item.quantity}
                                                                    onChange={(e) => handleQuantityChange(item.productID, parseInt(e.target.value))}
                                                                    min="1"
                                                                    style={{ width: '60px' }}
                                                                />
                                                            </div>
                                                            <p className="mb-0">{t('Total')}: <strong>{(item.productPrice * item.quantity).toFixed(2)} DH</strong></p>
                                                        </div>
                                                        <div className="flex-shrink-0 ms-2">
                                                            <a href="#" className="text-muted px-1" onClick={() => handleRemoveItem(item.productID)}>
                                                                <i className="mdi mdi-trash-can-outline" style={{ fontSize: '24px', cursor: 'pointer' }}></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        <br /><br />
                                        <h2>{t('Informations_client')}</h2>
                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <input type="text" name="Name" placeholder={t('Nom')} className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="mb-3">
                                                <input type="text" name="Phone" placeholder={t('Numéro_de_Téléphone')} className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="mb-3">
                                                <input type="text" name="Address" placeholder={t('Adresse')} className="form-control" onChange={handleInputChange} required />
                                            </div>
                                         <button
    type="submit"
    className="btn"
    disabled={isSubmitting}
    style={{
        backgroundColor: '#336734',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        fontSize: '16px',
        borderRadius: '5px',
        fontWeight: 'bold',
        cursor: isSubmitting ? 'not-allowed' : 'pointer',
        opacity: isSubmitting ? 0.7 : 1
    }}
>
    {isSubmitting ? t('En_cours') + '...' : t('Confirmer_commande')}
</button>
                                        </form>
                                    </>
                                ) : (
                                    <p>{t('Panier_vide')}.</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4">
                    <div className="mt-5 mt-lg-0">
                        <div className="card border shadow-none">
                            <div className="card-header bg-transparent border-bottom py-3 px-4">
                                <h5 className="font-size-16 mb-0">{t('Resume_commande')}</h5>

                            </div>
                            <input
  type="text"
  name="codepromo"
  placeholder={t('Code_promo')}
  className="form-control"
  onChange={(e) => setCodePromo(e.target.value)}
/>

<div style={{ display: "flex", justifyContent: "center" }}>
<button
  type="button"
  onClick={handlePromoCodeApply}
  disabled={role === 'supplier'} // 🔒 disables if user is a client
  style={{
    backgroundColor: "#336734",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    margin: "5px 0px",
    borderRadius: "5px",
    cursor: role === 'supplier' ? "not-allowed" : "pointer",
    opacity: role === 'supplier' ? 0.6 : 1,
  }}
>
{t('Appliquer_code_promo')}</button>
</div>
                            <div className="card-body p-4 pt-2">
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <tbody>
                                            {/* Calculate subtotal */}
                                            <tr>
                                                <td>{t('Sous_total')}</td>
                                                <td className="text-end">
  {discount > 0 ? (
    <span>
     {discount .toFixed(2)} DH
    </span>

  ) : (
    <span>
      {cart.reduce((total, item) => total + item.productPrice * item.quantity, 0).toFixed(2)} DH
    </span>
  )
  }
</td>

                                            </tr>
                                            {/* Define the discount amount */}
                                            <tr>
  <td>{t('Frais_livraison')}</td>
  <td className="text-end">
{t('livraison_gratuite')}
   
  </td>
</tr>

<tr className="bg-light">
  <th>{t('Total')} :</th>
  <td className="text-end">
    <span className="fw-bold">
      {calculateTotal().toFixed(2)} DH
    </span>
  </td>
</tr>

                                        </tbody>
                                    </table>
                                </div>
                                {/* end table-responsive */}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default CheckoutForm;
